import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';
import AddNewQuestionModal from './AddNewQuestionModal';
import { StyledButton } from '../../../Components/Generics.styled';

const CreateQuestionsContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    margin-top: 80px;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-bottom: 50px;
`;

const StyledNavButtons = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const DeleteIconDiv = styled.div`
    cursor: pointer;
`;

const QuestionsContainer = styled.div`
    margin-left: auto;
    margin-right: auto;
`;

const CreateQuestions = (props) => {
    const {
        handleNavButtonBack,
        handleNavButtonNext,
        tableRows,
        setTableRows,
        setLeadGenerationData,
        leadGenerationData,
    } = props;

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [rowUpdate, setRowUpdate] = useState({ type: 'add', idx: '' });

    const [questionData, setQuestionData] = useState({
        questionText: '',
        place: '',
        placeholder: '',
        isRequired: false,
        inputType: '',
        responseFormat: '',
        inputOptions: [],
    });

    function createData(
        questionText,
        placeholder,
        isRequired,
        inputType,
        responseFormat,
        inputOptions,
        place
    ) {
        return {
            questionText,
            placeholder,
            isRequired,
            inputType,
            responseFormat,
            inputOptions,
            place,
        };
    }

    const addExistingQuestionsToRows = () => {
        setTableRows({ rows: leadGenerationData.questions });
    };

    useEffect(() => {
        addExistingQuestionsToRows();
    }, []);

    const resetFields = () => {
        setQuestionData({
            questionText: '',
            place: '',
            placeholder: '',
            isRequired: false,
            inputType: '',
            responseFormat: '',
            inputOptions: [],
        });
    };

    const addDataToRows = () => {
        const { rows } = tableRows;
        if (rowUpdate.type === 'add') {
            if (rows) {
                rows.push(
                    createData(
                        questionData.questionText,
                        questionData.placeholder,
                        questionData.isRequired,
                        questionData.inputType,
                        questionData.responseFormat,
                        questionData.inputOptions,
                        questionData.place
                    )
                );
                setTableRows({ rows });
            }
        } else if (rowUpdate.type === 'edit') {
            rows[rowUpdate.idx] = {
                questionText: questionData.questionText,
                placeholder: questionData.placeholder,
                isRequired: questionData.isRequired,
                inputType: questionData.inputType,
                responseFormat: questionData.responseFormat,
                inputOptions: questionData.inputOptions,
                place: rowUpdate.idx,
                _id: rows[rowUpdate.idx]._id,
            };

            setTableRows({ ...tableRows, rows });
        }
        setModalIsOpen(false);
        resetFields();
    };

    const newArray = tableRows.rows;
    const handleRowDelete = (idx) => {
        tableRows.rows.forEach((item, tableIdx) => {
            if (idx === tableIdx) {
                newArray.splice(idx, 1);
                setTableRows({ rows: newArray });
            }
        });
    };

    const handleRowEdit = (idx) => {
        setRowUpdate({ type: 'edit', idx });
        tableRows.rows.forEach((item, tableIdx) => {
            if (idx === tableIdx) {
                const updatedRowObject = tableRows.rows[idx];

                setModalIsOpen(true);
                setQuestionData({ ...updatedRowObject });
            }
        });
    };

    const addRowBtn = (tableRowsLength) => {
        setRowUpdate({ type: 'add' });
        setQuestionData({
            ...questionData,
            place: tableRowsLength,
        });
        setModalIsOpen(true);
    };

    const questionsNextBtn = () => {
        setLeadGenerationData({ ...leadGenerationData, questions: tableRows.rows });
        handleNavButtonNext();
    };

    const noRows = tableRows?.rows?.length < 1;

    return (
        <CreateQuestionsContainer>
            <Title>Add Your Questions</Title>

            <QuestionsContainer>
                <div>
                    <div
                        style={{
                            width: '100%',
                            maxWidth: '1500px',
                            display: 'table',
                            tableLayout: 'fixed',
                        }}
                    >
                        <TableContainer
                            style={{
                                border: '1px solid black',
                                borderRadius: '12px',
                                backgroundColor: ' #fafbf7',
                            }}
                            component={Paper}
                        >
                            <Table sx={{ minWidth: 900 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Question</TableCell>
                                        <TableCell align="left">Placeholder</TableCell>
                                        <TableCell align="left">Is Required?</TableCell>
                                        <TableCell align="left">Input Type</TableCell>
                                        <TableCell align="left">Response Format</TableCell>
                                        <TableCell align="left">Input Options</TableCell>
                                        <TableCell align="center">Delete</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableRows?.rows?.map((row, idx) => (
                                        <TableRow
                                            onClick={() => handleRowEdit(idx)}
                                            hover
                                            key={idx + 1}
                                            sx={{
                                                '&:last-child td, &:last-child th': { border: 0 },
                                            }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {row.questionText}
                                            </TableCell>
                                            <TableCell>{row.placeholder}</TableCell>
                                            <TableCell>{row.isRequired ? 'Yes' : 'No'}</TableCell>
                                            <TableCell>{row.inputType}</TableCell>
                                            <TableCell>{row.responseFormat}</TableCell>
                                            <TableCell>
                                                {row?.inputOptions?.map((item, idx) => (
                                                    <div key={idx + 1}>{`${item} `}</div>
                                                ))}
                                            </TableCell>
                                            <TableCell align="center">
                                                <DeleteIconDiv onClick={() => handleRowDelete(idx)}>
                                                    <DeleteIcon />
                                                </DeleteIconDiv>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
                {noRows ? (
                    <div
                        style={{
                            textAlign: 'center',
                            backgroundColor: 'white',
                        }}
                    >
                        We already collect, Name, Email and Phone. Please add any additional
                        questions.
                    </div>
                ) : null}
                <br />
                <StyledButton
                    style={{ float: 'right' }}
                    variant="contained"
                    color="primary"
                    onClick={() => addRowBtn(tableRows?.rows?.length)}
                >
                    Add +
                </StyledButton>{' '}
            </QuestionsContainer>
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonBack()}
                >
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => questionsNextBtn()}
                    disabled={tableRows?.rows?.length === 0}
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
            <AddNewQuestionModal
                modalIsOpen={modalIsOpen}
                setModalIsOpen={setModalIsOpen}
                questionData={questionData}
                setQuestionData={setQuestionData}
                resetFields={resetFields}
                addDataToRows={addDataToRows}
            />
        </CreateQuestionsContainer>
    );
};

CreateQuestions.propTypes = {
    handleNavButtonNext: propTypes.func,
    handleNavButtonBack: propTypes.func,
    tableRows: propTypes.shape({
        rows: propTypes.array,
    }),
    setTableRows: propTypes.func,
    setLeadGenerationData: propTypes.func,
    leadGenerationData: propTypes.shape({ questions: propTypes.array }),
};

CreateQuestions.defaultProps = {
    handleNavButtonNext: () => {},
    handleNavButtonBack: () => {},
};
export default CreateQuestions;
